<template>
  <div class="flex flex_between">
    <md-field>
      <label>{{ $t("seller.upload.Currency") }}</label>
      <TbSelect v-model="selectedValues" md-dense multiple
				:search-allow="true"
				:options="options"
				options-value-field="isoCode"
				options-display-field="isoCode"
				ref="select"
	  />
    </md-field>
  </div>
</template>
<script>
  import {currencyApi} from "@/common/api/currencyApi";

  export default {
  props: {
    labelText: { type: String},
    columnName: { type: String},
    initialValues: { type: Array, default: [] },
  },
  data() {
    return {
      selectedValues: this.initialValues.map(value => String(value)),
      options: []
    };
  },
  created() {
	this.loadCurrencies();
  },
  methods: {
	loadCurrencies() {
		currencyApi.ListEnabled()
			.then((res) => this.options = res)
			.catch(this.toast);
	},
    clearFilter() {
      this.selectedValues = [];
		this.$refs.select.resetSearch();
    },
    getFilter() {
      if (this.selectedValues.length === 0) {
        return null;
      }
      return [{
        columnName: this.columnName,
        fieldType: "S",
        matchType: "IN",
        value: this.selectedValues.join(",")
      }];
    },
    setFilter(filter) {
      this.selectedValues = filter.value.split(",");
    }
  }
};
</script>
